<template>
  <layout-main-inner
    v-loading="loading"
    title="考卷管理"
    class="flex-1">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">新增考卷</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <el-form
        slot="form"
        class="form-item-mt0"
        style="flex: 1"
        label-width="90px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="考试科目：">
              <subject-select
                v-model="config.subjectId"
                showAll />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="考卷名称：">
              <el-input
                v-model="config.paperName"
                clearable
                placeholder="请输入考卷名称"
                @clear="handleCurrentChange(1)">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleCurrentChange(1)"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="考卷名称"
          fixed="left"
          min-width="240"
          prop="paperName"></el-table-column>
        <el-table-column
          label="考试科目"
          min-width="140"
          prop="subjectName"></el-table-column>
        <el-table-column
          label="答题时间(分钟)"
          min-width="120"
          prop="examMinutes"></el-table-column>
        <el-table-column
          label="考卷总分(分)"
          min-width="100"
          prop="paperScore"></el-table-column>
        <el-table-column
          label="考卷题量"
          min-width="80"
          prop="questionCount"></el-table-column>
        <el-table-column
          label="使用次数"
          min-width="70"
          prop="usedExamCount"></el-table-column>
        <el-table-column
          label="状态"
          min-width="60"
          prop="status">
          <template slot-scope="{ row }">{{ row.status | questionStatusName() }}</template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="150">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.usedExamCount > 0"
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              :disabled="row.usedExamCount > 0"
              type="text"
              @click="deleteitem(row)">删除</el-button>
            <el-button
              type="text"
              @click="previewitem(row)">考题信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <examination-paper-modal
      ref="paper"
      :callback="getlist" />
    <examination-paper-info-modal ref="info" />
  </layout-main-inner>
</template>
<script>
import ExaminationPaperInfoModal from './busi/examination-paper-info-modal.vue'
import examinationPaperModal from './busi/examination-paper-modal.vue'
import SubjectSelect from '../subject-select.vue'
export default {
  name: 'ExaminationPaperList',
  components: { examinationPaperModal, ExaminationPaperInfoModal, SubjectSelect },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, subjectId: null, paperName: '' }
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    additem() {
      this.$refs.paper.init()
    },
    updateitem(row) {
      const { id, subjectId, subjectName, examMinutes, paperName, paperType, status, questionCombinations } = row
      this.$refs.paper.init({
        id, subjectId, subjectName, examMinutes, paperName, paperType, status, questionCombinations
      })
    },
    previewitem(row) {
      const { paperName, questionCombinations } = row
      this.$refs.info.init({ paperName, questionCombinations })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该考卷?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.deleteexampaper({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$examApi.getexampapers(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records.map(i => {
              const questionCount = i.questionCombinations.map(s => s.questionCount).reduce((m, n) => m + n, 0)
              return { ...i, questionCount }
            })
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
